import * as TerminalHelper from "helpers/TermialHelper";

class ConfigHelper {
  getAddToCartOption() {
    const settings = TerminalHelper.getTerminalSettings();
    return settings.addToCart;
  }

  preventNegativeStockBilling() {
    const settings = TerminalHelper.getTerminalSettings();
    return settings.preventNegativeStock || "allow_negative_stock";
  }

  invoiceDisplayRateOption() {
    const settings = TerminalHelper.getTerminalSettings();
    return settings.invoiceDisplayRate;
  }
}

const configHelper = new ConfigHelper();
export default configHelper;
